$(function () {
  if (!customElements.get('about-social-responsibility')) {
    customElements.define(
      'about-social-responsibility',
      class aboutSocialResponsibility extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const $mySwiper = $(this).find('.mySwiper')[0];
          const $slide = $(this).find('.swiper-slide');
          let $scrollbarDom = $(this).find('.swiper-scrollbar')[0];
          let swiper;
          if ($slide.length > 1) {
            swiper = new Swiper($mySwiper, {
              spaceBetween: 24,
              scrollbar: {
                el: $scrollbarDom,
                draggable: true,
              },
            });
          }
        }
      }
    );
  }
});
